export function KPICard({ title, value, icon, color = 'teal', subtitle }) {
  const iconBg = {
    teal:   'bg-teal-50 text-[#0D9488]',
    orange: 'bg-orange-50 text-[#EA580C]',
    blue:   'bg-blue-50 text-[#2563EB]',
    green:  'bg-emerald-50 text-[#059669]',
    red:    'bg-red-50 text-[#DC2626]',
    purple: 'bg-purple-50 text-[#7C3AED]',
    amber:  'bg-amber-50 text-[#D97706]',
    gray:   'bg-gray-50 text-[#6B7280]',
  };

  return (
    <div
      className="bg-white border border-gray-200 rounded-lg p-5 hover:shadow-sm transition-shadow"
      data-testid={`kpi-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-[#6B7280] mb-2">{title}</p>
          <p className="text-3xl font-bold text-[#1A1A2E]">{value}</p>
          {subtitle && <p className="text-xs text-[#9CA3AF] mt-1">{subtitle}</p>}
        </div>
        {icon && (
          <div className={`p-2.5 rounded-lg ${iconBg[color] || iconBg.teal}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
